import { create } from 'zustand';

interface FiltersState {
  activeStatusFilters: (number | string)[];
  searchTerm: string;
  postuladoFilter: boolean | null;
  adjudicadoFilter: boolean | null;
  noLeidasFilter: boolean | null;
  fechaCierreDesde: string | null;
  fechaCierreHasta: string | null;
  fechaPublicacionDesde: string | null;
  fechaPublicacionHasta: string | null;
  toggleStatusFilter: (status: number | string) => void;
  clearAllFilters: () => void;
  setSearchTerm: (term: string) => void;
  setPostuladoFilter: (value: boolean | null) => void;
  setAdjudicadoFilter: (value: boolean | null) => void;
  setNoLeidasFilter: (value: boolean | null) => void;
  setFechaCierreDesde: (value: string | null) => void;
  setFechaCierreHasta: (value: string | null) => void;
  setFechaPublicacionDesde: (value: string | null) => void;
  setFechaPublicacionHasta: (value: string | null) => void;
}

export const useFiltersStore = create<FiltersState>((set) => ({
  activeStatusFilters: [],
  searchTerm: '',
  postuladoFilter: null,
  adjudicadoFilter: null,
  noLeidasFilter: null,
  fechaCierreDesde: null,
  fechaCierreHasta: null,
  fechaPublicacionDesde: null,
  fechaPublicacionHasta: null,

  toggleStatusFilter: (status) => {
    set((state) => ({
      activeStatusFilters: state.activeStatusFilters.includes(status)
        ? state.activeStatusFilters.filter((s) => s !== status)
        : [...state.activeStatusFilters, status],
    }));
  },

  clearAllFilters: () => {
    set({
      activeStatusFilters: [],
      searchTerm: '',
      postuladoFilter: null,
      adjudicadoFilter: null,
      noLeidasFilter: null,
      fechaCierreDesde: null,
      fechaCierreHasta: null,
      fechaPublicacionDesde: null,
      fechaPublicacionHasta: null,
    });
  },

  setSearchTerm: (term) => {
    set({ searchTerm: term });
  },

  setPostuladoFilter: (value) => {
    set({ postuladoFilter: value });
  },

  setAdjudicadoFilter: (value) => {
    set({ adjudicadoFilter: value });
  },

  setNoLeidasFilter: (value) => {
    set({ noLeidasFilter: value });
  },

  setFechaCierreDesde: (value) => {
    set({ fechaCierreDesde: value });
  },

  setFechaCierreHasta: (value) => {
    set({ fechaCierreHasta: value });
  },

  setFechaPublicacionDesde: (value) => {
    set({ fechaPublicacionDesde: value });
  },

  setFechaPublicacionHasta: (value) => {
    set({ fechaPublicacionHasta: value });
  },
}));
